<p class="text-md font-bold">Manual Transaction Types</p>
<pr-information-box>
  These are selectable types when taking manual transactions. Manual
  Transactions are grouped by these labels in reconciliation reporting.
</pr-information-box>
<div class="flex flex-col gap-4">
  <pt-buttons-container>
    <button mat-flat-button color="primary" (click)="addType()">
      Create Transaction Type
    </button>
  </pt-buttons-container>
  <ng-container *ngrxLet="activeTypes$; let types">
    @if (!types.length) {
      <pr-empty-state image="list" title="transaction types" />
    } @else {
      <mat-list>
        @for (type of types; track type.ref.path) {
          <mat-list-item>
            <div class="flex items-center gap-4">
              <div class="flex-1">{{ type.name }}</div>
              <div>
                <button mat-icon-button (click)="addType(type)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  (click)="deleteTransactionType(type)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </mat-list-item>
        }
      </mat-list>
    }
  </ng-container>

  <ng-container *ngrxLet="deletedTypes$; let deletedTypes">
    @if (deletedTypes.length) {
      <mat-list>
        <h3
          mat-subheader
          class="collapsible-subheader"
          (click)="deletedContent.toggle()"
        >
          Deleted Types
          <mat-icon>
            {{ deletedContent.expanded ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </h3>
        <pt-collapsible #deletedContent>
          <ng-template ptCollapsibleContent>
            @for (type of deletedTypes; track type.ref.path) {
              <mat-list-item>
                <div class="flex items-center gap-4">
                  <div class="flex-1">{{ type.name }}</div>

                  <div matTooltip="Restore">
                    <button mat-icon-button (click)="restore(type)">
                      <mat-icon>restore</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-list-item>
            }
          </ng-template>
        </pt-collapsible>
      </mat-list>
    }
  </ng-container>
</div>
